import React from 'react';
import { Typography } from '@mui/material';

/** "Powered by GIPHY" attribution required by GIPHY's terms wherever its GIFs are shown. */
const GiphyAttribution = ({ sx }) => (
  <Typography
    variant="caption"
    component="div"
    sx={{
      fontSize: '0.65rem', fontWeight: 600, letterSpacing: 0.3, opacity: 0.75, lineHeight: 1.4, ...sx,
    }}
  >
    Powered by GIPHY
  </Typography>
);

export default GiphyAttribution;
